import React, { useRef, useEffect, useState } from "react";
import { GEO } from "./data";
import "./style.css";

const LocationDetectAndInput = ({ formValues, setFormValues, errors }) => {
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState(formValues.address);
  
  useEffect(() => {
    if (formValues.address && formValues.address !== inputValue) {
      setInputValue(formValues.address);
    }
  }, [formValues.address]);

  useEffect(() => {
    if (!window.google || !window.google.maps) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      { types: ["geocode"] }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const address = place.formatted_address;

        setInputValue(address);
        setFormValues((prev) => ({
          ...prev,
          lat: lat,
          lng: lng,
          address,
        }));
      }
    });
  }, [setFormValues]);


  const handleDetectLocation = async () => {
  if (!navigator.geolocation) {
    alert("Geolocation not supported by this browser.");
    return;
  }

  try {
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        timeout: 10000,
      });
    });

    const lat = position.coords.latitude;
    const lng = position.coords.longitude;

    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GEO}`
    );

    if (!response.ok) {
      throw new Error("Failed to fetch address.");
    }

    const data = await response.json();
    const address = data.results[0]?.formatted_address || "Address not found";

    setInputValue(address);
    setFormValues((prev) => ({
      ...prev,
      latitude: lat,
      longitude: lng,
      address,
    }));
  } catch (error) {
    alert("Unable to detect location. Please try again.");
  } finally {
    //setLoading(false); // Clear loading state
  }
};

  return (
    <div className="col-md-12 mb-3">
      {/* <label className="form-label">Location</label> */}
      <div className="d-flex gap-2">
        <input
          ref={inputRef}
          type="text"
          className="form-control"
          placeholder="Search or use current location"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={()=>handleDetectLocation()}
        >
          Use Current
        </button>
      </div>

      {errors && <p className="text-danger er">{errors.address}</p>}

      <input type="hidden" name="latitude" value={formValues.latitude} />
      <input type="hidden" name="longitude" value={formValues.longitude} />
      <input type="hidden" name="address" value={formValues.address} />
    </div>
  );
};

export default LocationDetectAndInput;